
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { getFilterValues, getHotelsFiltersNotEmptyFields, getHotelsFiltersType, isCarsFiltersEmpty, isFiltersEmpty } from '@utils';
import { carsFiltersActions, filtersActions } from '@share/store/slices';
import { HomesTypes } from '@share/constants';
import { isAllInclusiveFromQuery, RootState, isDisplayCertificates } from '@share/utils';
import { IAccount } from '@share/common-types';

import { SelectedFiltersItem } from '../selected-filters-item';

import './style.scss';

interface IProps {
  title?: string;

  isVacationRentals?: boolean | null | undefined;
  isCars?: boolean | null | undefined;

  isCentered?: boolean;
  displayClearAll?: boolean;
  displayClearAllHeader?: boolean;

  onFiltersOrSortChange: (isSortChange?: boolean) => void;
}

export function SelectedFiltersBase(props: IProps) {
  const { isCars, isVacationRentals, isCentered, displayClearAll, displayClearAllHeader, title, onFiltersOrSortChange } = props;

  const hotelsStore = useSelector((state: RootState) => state.hotelsStore);
  const filtersStore = useSelector((state: RootState) => state.filtersStore);

  const carsStore = useSelector((state: RootState) => state.carsStore);
  const carsFiltersStore = useSelector((state: RootState) => state.carsFiltersStore);

  const account = useSelector((state: RootState) => state.loginStore.account);
  
  const { loadingFilter: loadingFilterCars } = carsStore;
  const { loadingFilter: loadingFilterHotels } = hotelsStore;

  const { searchHomes } = filtersStore;

  const isFiltersAppliedHotels = !isFiltersEmpty(filtersStore, account as IAccount, isVacationRentals);
  const isFiltersAppliedCars = !isCarsFiltersEmpty(carsFiltersStore);

  const notEmptyFieldsHotels = !isCars ? getHotelsFiltersNotEmptyFields(filtersStore, account as IAccount, isVacationRentals) : [];

  const isSearchHomesApplied = !isCars && !isVacationRentals && searchHomes !== HomesTypes.All;

  const filterValues =  getFilterValues(isCars ? carsFiltersStore : filtersStore, notEmptyFieldsHotels, isCars);

  const dispatch = useDispatch();

  const loadingFilter = isCars ? loadingFilterCars : loadingFilterHotels;
  const isFiltersApplied = isCars ? isFiltersAppliedCars : isFiltersAppliedHotels;
  
  if (!isFiltersApplied || loadingFilter || (!filterValues.length && !isSearchHomesApplied)) {
    return null;
  }

  const handleClearAll = () => {
    if(isCars) {
      dispatch(carsFiltersActions.resetFilters());
    } else {
      const restrictedVacationRentalsList = account?.restrictedVacationRentalsList;
      const type = getHotelsFiltersType(account as IAccount, isVacationRentals);
      dispatch(
        filtersActions.resetFiltersByType({
          filterType: { type, list: restrictedVacationRentalsList },
          isQuickEnabled: account?.hasQuick || false,
          displayCertificates: isDisplayCertificates(account as IAccount),
        }),
      );
    }
    onFiltersOrSortChange(true);
  };

  return (
    <div className={`selected-filters-header ${isCentered ? 'centered-values' : ''}`}>
      {title && (
        <div className="selected-filters-header__title">
          <FormattedMessage id={title} />
        </div>)}

      <SelectedFiltersItem isVacationRentals={isVacationRentals} isCars={isCars} onFiltersOrSortChange={onFiltersOrSortChange} displayClearAll={displayClearAllHeader} />
      
      {displayClearAll && filterValues.length > 1 && (
        <div className="selected-filters-header__clear-all" onClick={handleClearAll}>
          <FormattedMessage id="clearAll" />
        </div>)}
    </div>
  );
}
